import { Chip, IconButton, Tooltip } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import { Done, Remove, Visibility, VisibilityOff } from '@material-ui/icons';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import React from 'react';

const Acciones = ({ item, classes, onEdit, onDelete, onDeactivate }) => {
  return (
    <TableCell className={classes.tableCellAction}>
      <Tooltip title="Editar" aria-label="editar">
        <IconButton aria-label="editar" onClick={() => onEdit && onEdit(item)}>
          <EditIcon />
        </IconButton>
      </Tooltip>
      <Tooltip
        title={item.activado ? 'Inactivar' : 'Activar'}
        aria-label="activar/desactivar"
      >
        <IconButton
          aria-label="delete"
          onClick={() => onDeactivate && onDeactivate(item)}
        >
          {item.activado ? <Visibility /> : <VisibilityOff />}
        </IconButton>
      </Tooltip>
      <Tooltip title="Eliminar" aria-label="eliminar">
        <IconButton
          aria-label="delete"
          onClick={() => onDelete && onDelete(item)}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </TableCell>
  );
};

const personaConfig = ({
  classes,
  onView,
  onEdit,
  onDelete,
  onDeactivate,
  enqueueSnackbar
}) => {
  return {
    entrega: {
      datosConfig: {
        titulo: 'Seleccione quién entregará las mercaderías',
        servicio: 'persona',
        url: 'persona'
      },
      datosSettings: {
        nombre: {
          label: 'Nombre',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>{item.nombre}</TableCell>
          )
        },
        apellido: {
          label: 'Apellido',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>{item.apellido}</TableCell>
          )
        },
        nroDocumento: {
          label: 'Nro documento',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.nroDocumento || ''}
            </TableCell>
          )
        }
      }
    },
    personaList: {
      datosConfig: {
        titulo: 'Seleccione quién entregará las mercaderías',
        servicio: 'persona',
        url: 'persona'
      },
      datosSettings: {
        nombre: {
          label: 'Nombre',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>{item.nombre}</TableCell>
          )
        },
        apellido: {
          label: 'Apellido',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>{item.apellido}</TableCell>
          )
        },
        nroDocumento: {
          label: 'Nro documento',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.nroDocumento || ''}
            </TableCell>
          )
        },
        activado: {
          label: 'Activo',
          type: 'string',
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              <Chip
                variant="outlined"
                color={item.activado ? 'primary' : 'secondary'}
                size="small"
                icon={item.activado ? <Done /> : <Remove />}
                label={item.activado ? 'activo' : 'inactivo'}
              />
            </TableCell>
          )
        },
        actions: {
          label: 'Acciones',
          sortable: false,
          cellRendering: item => (
            <Acciones
              item={item}
              classes={classes}
              enqueueSnackbar={enqueueSnackbar}
              onView={onView}
              onEdit={onEdit}
              onDelete={onDelete}
              onDeactivate={onDeactivate}
            />
          )
        }
      }
    }
  };
};

export default personaConfig;
